import type PodonexConfigurationInterface from '@/domains/settings/typescript/interfaces/PodonexConfigurationInterface';
import type PodonexConfigurationEditDTOInterface from '@/domains/settings/typescript/interfaces/PodonexConfigurationEditDTOInterface';

export default function transformPodonexConfigurationToEditDTO(
    settings: PodonexConfigurationInterface,
): PodonexConfigurationEditDTOInterface {
    return {
        scanner: settings.scannerId,
        owner: settings.userId,
        lightSensibility: settings.lightSensibility,
        threshold: Number(settings.sobelThreshold),
        steps: Number(settings.cleaningSteps),
        brightness: settings.brightness,
        contrast: settings.contrast,
        macBrightness: Number(settings.macBrightness),
        macContrast: Number(settings.macContrast),
        negativeBrightness: settings.negativeBrightness,
        negativeContrast: settings.negativeContrast,
        negativeMacBrightness: settings.negativeMacBrightness ? Number(settings.negativeMacBrightness) : undefined,
        negativeMacContrast: settings.negativeMacContrast ? Number(settings.negativeMacContrast) : undefined,
        podonexVersionChannel: settings.podonexVersionChannel,
    };
}
